import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { buildReport } from './report/reportModel';
import ReportView from './report/ReportView';
import { ExampleWorkbookLink } from './exampleFiles';

// The example is the <JOB>_olink_report.json the olink-proteomics 2.0.0 script
// wrote for the example workbook: made-up protein values scored as a
// 58-year-old man with BMI 29.4. The profile spread comes from the summary
// workbook of the same run.
const EXAMPLE_FACTS = Object.freeze({ age: 58, sex: 'Male', bmi: 29.4 });
const EXAMPLE_TECHNICAL = Object.freeze({ residualSpread: 0.8918231336747097, beyondThreeSdFraction: 0 });

export default function ExampleReport() {
  const [state, setState] = useState({ state: 'loading' });

  useEffect(() => {
    let cancelled = false;
    import('../example/example-report.json')
      .then((module) => {
        const report = buildReport(module.default);
        if (!cancelled) setState({ state: 'ready', report });
      })
      .catch((error) => {
        if (!cancelled) setState({ state: 'error', error: error.message });
      });
    return () => { cancelled = true; };
  }, []);

  const notice = (
    <div className="PROTEORISK-example-notice">
      <i className="fas fa-flask" aria-hidden="true" />
      <div>
        <strong>This is an example</strong>
        <p>
          It uses made-up protein values, so it does not describe a real person. Your own report looks
          the same, filled in from your workbook. The example workbook gives exactly this report when you
          enter age 58, sex Male and BMI 29.4.
        </p>
        <ExampleWorkbookLink />
      </div>
      <Link to="/proteorisk" className="PROTEORISK-button primary">
        <i className="fas fa-arrow-right" aria-hidden="true" /> Start your own analysis
      </Link>
    </div>
  );

  return (
    <div className="PROTEORISK-page PROTEORISK-job-page">
      <div className="PROTEORISK-job-header">
        <Link to="/proteorisk" className="PROTEORISK-back">
          <i className="fas fa-arrow-left" aria-hidden="true" /> Home
        </Link>
        <div className="PROTEORISK-job-header-main">
          <div>
            <h1>Example report</h1>
            <p>Made-up protein values, scored by the same model your analysis uses</p>
          </div>
        </div>
      </div>
      {state.state === 'loading' && (
        <div className="PROTEORISK-section PROTEORISK-loading"><i className="fas fa-spinner fa-spin" aria-hidden="true" /> Loading the example...</div>
      )}
      {state.state === 'error' && (
        <section className="PROTEORISK-section PROTEORISK-status-card failed">
          <h2><i className="fas fa-exclamation-circle" aria-hidden="true" /> The example could not be shown</h2>
          <p>{state.error}</p>
        </section>
      )}
      {state.state === 'ready' && (
        <ReportView report={state.report} facts={EXAMPLE_FACTS} technical={EXAMPLE_TECHNICAL} notice={notice} />
      )}
    </div>
  );
}
